import { Button } from '@codegouvfr/react-dsfr/Button';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export const EtablissementBottomInfoCard = ({ etablissementId, rncpsCount }: EtablissementChildrenCardProps) => {
  const navigate = useNavigate();

  return (
    <>
      <div className={'separator'} />

      <div className={'flex flex-row place-content-between items-center'}>
        <span>{rncpsCount ?? 0} RNCP</span>
        <Button iconId={'fr-icon-add-line'}
                priority={'secondary'}
                className={'uppercase'}
                onClick={() => navigate(`/mon-ofa/edition/etablissement/${etablissementId}/rncp`)}>
          Associer des RNCP</Button>
      </div>
    </>
  );
};

interface EtablissementChildrenCardProps {
  etablissementId: number;
  rncpsCount: number;
}